import { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ToastContext } from '@reveni-io/reveni-ui'

import { getFilterParams } from '@/metrics/helpers/helpers'
import metricsServices from '@/metrics/services/services'

import { getFilenameFromHeaders, triggerDownload } from './helpers'

const useCustomerNotesExport = ({ reasonId, storeId, filters }) => {
  const [exporting, setExporting] = useState(false)
  const { setToastInfo } = useContext(ToastContext)
  const { t } = useTranslation()

  const exportToCsv = async () => {
    setExporting(true)

    try {
      const response = await metricsServices.exportCustomerNotesAnalysis({
        reasonId,
        storeId,
        params: getFilterParams(filters),
      })

      const filename = getFilenameFromHeaders(response?.headers)
      const blob = new Blob([response?.data], { type: 'text/csv;charset=utf-8' })

      triggerDownload({ blob, filename })
    } catch {
      setToastInfo({ show: true, message: t('No se pudo descargar el CSV. Inténtalo de nuevo.'), type: 'error' })
    } finally {
      setExporting(false)
    }
  }

  return { exportToCsv, exporting }
}

export default useCustomerNotesExport
